<template>
    <div>
        <!-- News section starts here-->
        <!-- Left card container-->
        <div class="container">
            <!-- Left row-->
            <div class="row row-cols-1 row-cols-lg-1 " >
                <div class="col">
                  
                    <!-- News header card-->
                
                    <div class="actualnewscards" v-for="(news, index) in allnewsdata" :key="index" :id="index%2 > 0 ? 'oddnewsbg' : 'evennewsbg'">
                      <div class="buttons topbuttons">
                        <button class="btn btn-primary button is-light floatleftbtn" @click.prevent="$emit('goToPreviousPage', $event.target.value='movePrevious')" v-if="showPreviousButton"><i class="fa-solid fa-angles-left"></i> Previous</button>
                        <button class="btn btn-primary button is-light floatrightbtn" @click.prevent="$emit('goToNextPage', $event.target.value=myval='moveNext')" v-if="showNextButton">Next <i class="fa-solid fa-angles-right"></i></button>
                    </div>
                      <div style="margin-top: 40px;">
                        <a href="#" :id="`news.hpnewsid`" @click.prevent="$emit('getclickedId', $event.target.value=`${news.hpnewsid}`)"  style="text-decoration: none; margin-left: 20px;">
                            <span style="font-size: 20px; color: #003; cursor: pointer; padding-left: 20px; font-weight: bold;">DOWNLOAD PDF</span><i class="fa-regular fa-circle-down" style="font-size: 28px; padding-left: 10px; color: orangered;"></i>
                        </a>   
                       </div>   
                        <div class="card-title">{{ dateTime(news.hpnewsdate) }}</div>
                        <router-link  :to="{name: 'newsreading', params:{hpnewsid: `${news.hpnewsid}`}}" style="text-decoration: none; font-size: 20px;" @click.prevent><div class="hptitle" v-html="news.hpnewsdesc"></div></router-link>
                        <div class="max-lines" v-html="news.hpnewsdetail"></div>
                       
                        
                         <div class="buttons">
                            <button class="btn btn-primary button is-light floatleftbtn" @click.prevent="$emit('goToPreviousPage', $event.target.value='movePrevious')" v-if="showPreviousButton"><i class="fa-solid fa-angles-left"></i> Previous</button>
                            <button class="btn btn-primary button is-light floatrightbtn" @click.prevent="$emit('goToNextPage', $event.target.value=myval='moveNext')" v-if="showNextButton">Next <i class="fa-solid fa-angles-right"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
               
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
require('@/globalDeclare.js');
export default {
    props: ['allnewsdata', 'showNextButton', 'showPreviousButton', 'nextrecno'],
    data() {
        return {
          myPicUrl: '',
        }
    },

methods: {
  dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  goToNextPage($event) {
    // id: $event.target.value
    this.$emit('goToNextPage', $event.target.value)
    },
  goToPreviousPage($event) {
    // id: $event.target.value
    this.$emit('goToPreviousPage', $event.target.value)
    },
    getclickedId($event) {
    // id: $event.target.value
    this.$emit('getclickedId', $event.target.value)
    },
    
},
mounted() {
  this.myPicUrl = myUrlPath
}
}
</script>

<style scoped>
.container {
    padding-bottom: 100px;
}
.newscardheader {
    background-image: url("../assets/slide-5.jpg");
    color: white;
    font-size: 24px;
  }
  
  .card-header {
    background-color: white;
    color: #003;
    font-weight: bold;
    text-align: center;
  }
  .servicescards {
    background-image: url("../assets/slide-5.jpg");
    color: white;
  }
  
  .valuecards {
    margin-right: 20px; 
    border-radius: 5px; 
    width: 150px;
  }
  #oddnewsbg {
    color: grey;
    font-weight: normal;
    padding: 30px;
    background-color: beige;
  }
  
  #evennewsbg {
    color: grey;
    font-weight: normal;
    padding: 30px;
    margin-top: 40px;
  }
  .fa-readme {
    font-size: 30px;
    padding-top: 40px;
    padding-left: 10px;
    margin-top: 50px;
  }
  .newslearnmore {
    text-decoration: none;
    float: right;
    font-size: 18px;
    padding-right: 50px;
    color: #003;
  }
  .newscards {
    margin-top: 10px;
  }
  .newsphotoimage{
    width: 100%;
    height: 400px;
  
  }
  .newscardheader {
    color: white;
  }

  /*.max-lines {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show 
            line-clamp: 2; 
    -webkit-box-orient: vertical;
    font-weight: normal;

  }*/
  .buttons {
    padding-top: 80px;
    text-align: center;
  }
  .card-title {
    font-size: 13;
    color: rgb(90, 65, 1);
    font-weight: bold;
  }
  .hptitle {
    font-weight: bold;
    color: rgb(20, 75, 126);
    cursor: pointer;
  }
  .floatleftbtn {
    float:left;
  }
  .floatrightbtn {
    float: right;
  }
  .topbuttons {
    padding-bottom: 50px;
  }
  .btn-primary {
    background-color: #003;
    border-color: #003;
  }
  @media (min-width: 320px) and (max-width: 575.99px) {
  .col {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    background-image: none;
  }
  .newsphotoimage{
    width: 100%;
  }
  .newslearnmore{
    width: 100%;
    text-align: justify;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
   }
   /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .newsphotoimage{
      height: 280px;
      margin-bottom: 0px;
     }
     .newscard {
      height: auto;
     }
     .col {
      width: 100%;
     } 
     .card-text{
      font-size: 14px;
      font-weight: bold;
      text-align: left;
      width: 100%;
     }
     .formatsdgs {
      padding-left: 20px;
      padding-right: 20px;
  }
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
    .txtdata {
      margin-bottom: 200px;
      width: 600px;
      padding-right: 10px;
    }
  
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
   @media only screen and (min-width: 768px) {
    .txtdata {
      margin-bottom: 30px;
      width: 700px;
      padding-right: 10px;
    }
   }
   
   /* Large devices (laptops/desktops, 992px and up) */
   @media only screen and (min-width: 992px) {
    .services {
      padding-bottom: 100px;
    }
    .txtdata {
      margin-bottom: 30px;
      width: 800px;
      padding-right: 10px;
    }
   }
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1200px) {
    .txtdata {
      margin-bottom: 100px;
      width: 700px;
      padding-right: 10px;
    }
   } 
</style>